import { GET } from "../../APiHelper/API"

export const getDeletedLeaguesForSeasonAPI = (season_id, onSuccess, onError) => {

    GET(`/api/v1/leagues/seasons/${season_id}/deleted_leagues`, onSuccess, onError)
}